module.exports = __webpack_public_path__ + "35ad1fee3102f7251e614d6d4579f8ec.pdf";